module.exports = __webpack_public_path__ + "img/mintme.ce98ec9f.svg";